import { useFeatureSwitchEnabled } from '@hooks/useFeatureSwitchEnabled';
import { FEATURES_LIST } from 'src/context/featureSwitchApp';
import { IS_B2B, isMarketIT } from 'src/constants/main';

export const useIsShowPriceExcludedVAT = (isStockSlice: boolean = false) => {
    return (
        useFeatureSwitchEnabled(FEATURES_LIST.FEATURE_SWITCH_SHOW_PRICE_EXCLUDED_VAT) && !isStockSlice
    );
};
